// extracted by mini-css-extract-plugin
export default {"column":"SimulationParameters_column__5YiDE","simulation":"SimulationParameters_simulation__8pV4z","header":"SimulationParameters_header__RxwkV"};